import * as icons from '@ant-design/icons-vue';

export default (app) => {
	for (let name in icons) {
		app.component(name, icons[name]);
	}
}